var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 7.3625C6.875 7.19674 6.94085 7.03777 7.05806 6.92056C7.17527 6.80335 7.33424 6.7375 7.5 6.7375C7.66576 6.7375 7.82473 6.80335 7.94194 6.92056C8.05915 7.03777 8.125 7.19674 8.125 7.3625V11.1125C8.125 11.2783 8.05915 11.4372 7.94194 11.5544C7.82473 11.6717 7.66576 11.7375 7.5 11.7375C7.33424 11.7375 7.17527 11.6717 7.05806 11.5544C6.94085 11.4372 6.875 11.2783 6.875 11.1125V7.3625ZM7.5 4.28188C7.33424 4.28188 7.17527 4.34772 7.05806 4.46493C6.94085 4.58214 6.875 4.74112 6.875 4.90688C6.875 5.07264 6.94085 5.23161 7.05806 5.34882C7.17527 5.46603 7.33424 5.53188 7.5 5.53188C7.66576 5.53188 7.82473 5.46603 7.94194 5.34882C8.05915 5.23161 8.125 5.07264 8.125 4.90688C8.125 4.74112 8.05915 4.58214 7.94194 4.46493C7.82473 4.34772 7.66576 4.28188 7.5 4.28188Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 1.75C4.04813 1.75 1.25 4.54813 1.25 8C1.25 11.4519 4.04813 14.25 7.5 14.25C10.9519 14.25 13.75 11.4519 13.75 8C13.75 4.54813 10.9519 1.75 7.5 1.75ZM2.5 8C2.5 9.32608 3.02678 10.5979 3.96447 11.5355C4.90215 12.4732 6.17392 13 7.5 13C8.82608 13 10.0979 12.4732 11.0355 11.5355C11.9732 10.5979 12.5 9.32608 12.5 8C12.5 6.67392 11.9732 5.40215 11.0355 4.46447C10.0979 3.52678 8.82608 3 7.5 3C6.17392 3 4.90215 3.52678 3.96447 4.46447C3.02678 5.40215 2.5 6.67392 2.5 8Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/infoIcon.6538b3080144ffe1934ca2b295d96676.svg";
export { ForwardRef as ReactComponent };